
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return require("private-next-pages/privacy-policy/index.js");
      }
    ]);
  